import { resetAuthToken } from '@plugins/api';
import store from '@stores';

export default async function auth({ to, from, next, router }) {
  if (!localStorage.getItem('x-access-token')) {
    return next({ name: 'login' });
  } else if (!Object.keys(store.state.auth.user).length) {
    let response = await store.dispatch('auth/fetchUser');
    if (!response) {
      resetAuthToken();
      return next({ name: 'login' });
    }
  }

  const user = store.state.auth.user;
  //handle role based guard here
  let meta = to.meta;
  if (meta.role) {
    if (meta.role.except) {
      // allow for all role except
    } else if (meta.role.only) {
      const allowed = new Set(
        Array.isArray(meta.role.only) ? meta.role.only : [meta.role.only]
      );
      if (!allowed.has(user.role)) {
        if (from.name === 'login') {
          next('/');
          return;
        }
        $showError('You are not authorized for this action!');
        to.meta.originalLayout = to.meta.layout;
        to.meta.layout = 'Error';
        to.meta.code = 401;
      } else {
        if (to.meta.originalLayout) {
          to.meta.layout = to.meta.originalLayout;
          delete to.meta.originalLayout;
          delete to.meta.code;
        }
      }
    } else {
      throw new Error('Wrong role object provided!');
    }
  }

  return next();
}
